module.exports = __webpack_public_path__ + "static/media/aamani_maddukuri.a3d0b93b.png";